import React, { useState} from 'react'
import {Box} from '@mui/material'
import RichiesteSupportoContainer from '../pages/components/RichiesteSupportoContainer';
import './FooterMonitoraggio.css'


const FooterMonitoraggio = ({ idNodoPratica }) => {

  const [slideDownValue, setSlideDownValue] = useState(false);
  const [showRichiesteSupporto, setShowRichiesteSupporto] = useState(false);
  const [userLogged] = useState(JSON.parse(localStorage.getItem('user')));
  const [rispostaSupporto, setRispostaSupporto] = useState(false);



  const closeRichiesteSupporto = () => {
    setSlideDownValue(false);
    setShowRichiesteSupporto(false);
  };

  return(
    <>
      <Box
        className={'footer ' + (slideDownValue === true ? 'animationSlideDownAndUp' : '')} 
        sx={{ alignSelf: 'end', marginRight: '3%', position: 'fixed', bottom: '0px', right: '0px' }}
      >
        {showRichiesteSupporto && 
          <RichiesteSupportoContainer
            showRichiesteSupporto={showRichiesteSupporto}
            closeRichiesteSupporto={closeRichiesteSupporto}
            idNodoPratica={idNodoPratica}
            rispostaSupporto={rispostaSupporto}
          />
        }
      </Box>
    </>
  );
};

export default FooterMonitoraggio;